import React, { useState, useEffect, useContext } from 'react';
import HomieContext from 'HomieContext';
import {
  isWhatsappResendAllowed,
  minutesFromDate,
  WHATSAPP_RESEND_TIMEOUT,
  whatsappCodeExpired
} from 'utils/Date';
import NotifyConfirmation from 'actions/NotifyConfirmationActions';

const withWhatsappVerification = (
  Component,
  verificationType = 'home_application'
) => {
  return function WhatsappContainer(props) {
    const {
      currentUser: {
        id: currentUserId,
        lastCodeDate,
        codeCreationDate,
        mobile_phone: mobilePhone
      }
    } = useContext(HomieContext);
    const [canSendWhatsappCode, setCanSendWhatsappCode] = useState(
      isWhatsappResendAllowed(lastCodeDate || codeCreationDate)
    );

    useEffect(() => {
      const minutesUntilWhatsappResendAllowed =
        WHATSAPP_RESEND_TIMEOUT -
        minutesFromDate(lastCodeDate || codeCreationDate);

      if (minutesUntilWhatsappResendAllowed <= 0) {
        return;
      }

      const whatsappTimer = setTimeout(() => {
        setCanSendWhatsappCode(true);
      }, minutesUntilWhatsappResendAllowed * 60 * 1000);

      return () => {
        clearTimeout(whatsappTimer);
      };
    }, [canSendWhatsappCode]);

    useEffect(() => {
      if (
        (!lastCodeDate && !codeCreationDate) ||
        (codeCreationDate && whatsappCodeExpired(codeCreationDate))
      ) {
        NotifyConfirmation.sendCodeWhatsapp(
          currentUserId,
          mobilePhone.replace('+', ''),
          verificationType
        );
      }

      setCanSendWhatsappCode(
        isWhatsappResendAllowed(lastCodeDate || codeCreationDate)
      );
    }, [lastCodeDate, codeCreationDate]);

    return <Component {...props} canSendWhatsappCode={canSendWhatsappCode} />;
  };
};

export default withWhatsappVerification;
